import { ANONYMOUS_ID_KEY } from '@nwwp/segment-analytics'

const getAnonymousIdFromCookie = (): string | null => {
  const cookie = document.cookie
    .split(';')
    .map((value) => value.trim())
    .find((value) => value.startsWith(`${ANONYMOUS_ID_KEY}=`))

  if (!cookie) {
    return null
  }

  const raw = cookie.slice(ANONYMOUS_ID_KEY.length + 1)
  try {
    return decodeURIComponent(raw)
  } catch {
    return raw
  }
}

/**
 * Reads Segment's anonymous ID from localStorage or cookie.
 */
export const getAnonymousId = (): string | null => {
  const anonymousId = localStorage.getItem(ANONYMOUS_ID_KEY)
  if (!anonymousId) {
    return getAnonymousIdFromCookie()
  }

  try {
    const parsed: unknown = JSON.parse(anonymousId)
    return typeof parsed === 'string' ? parsed : anonymousId
  } catch {
    return anonymousId
  }
}
